import { combineReducers } from 'redux';
import passwordRecovery from './passwordRecovery';
import passwordReset from './passwordReset';

export default combineReducers({ passwordRecovery, passwordReset});
